var _ellipse, _ellipse2, _ellipse3, _path, _path2, _path3, _path4, _path5, _path6, _ellipse4, _ellipse5, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _rect, _rect2, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _ellipse6, _ellipse7, _path26, _path27, _path28, _path29, _path30, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoInc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 48,
    viewBox: "0 0 27 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.1461,
    cy: 46.0224,
    rx: 9.63832,
    ry: 1.27631,
    fill: "#C4C4C4",
    fillOpacity: 0.33
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.1469,
    cy: 46.0198,
    rx: 6.20549,
    ry: 0.836201,
    fill: "#C4C4C4",
    fillOpacity: 0.33
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.0117,
    cy: 46.0154,
    rx: 3.96095,
    ry: 0.484117,
    fill: "#C4C4C4",
    fillOpacity: 0.33
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9394 5.98825C18.9394 9.29547 16.299 11.9765 13.042 11.9765C9.7849 11.9765 7.14453 9.29547 7.14453 5.98825C7.14453 2.68103 9.7849 0 13.042 0C16.299 0 18.9394 2.68103 18.9394 5.98825Z",
    fill: "#E63451"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9394 5.98825C18.9394 9.29547 16.299 11.9765 13.042 11.9765C9.7849 11.9765 7.14453 9.29547 7.14453 5.98825C7.14453 2.68103 9.7849 0 13.042 0C16.299 0 18.9394 2.68103 18.9394 5.98825Z",
    fill: "url(#paint0_linear_3286_185)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9394 5.98825C18.9394 9.29547 16.299 11.9765 13.042 11.9765C9.7849 11.9765 7.14453 9.29547 7.14453 5.98825C7.14453 2.68103 9.7849 0 13.042 0C16.299 0 18.9394 2.68103 18.9394 5.98825Z",
    fill: "url(#paint1_linear_3286_185)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7755 6.52442C12.7755 7.65973 11.8691 8.58009 10.751 8.58009C9.63296 8.58009 8.72656 7.65973 8.72656 6.52442C8.72656 5.3891 9.63296 4.46875 10.751 4.46875C11.8691 4.46875 12.7755 5.3891 12.7755 6.52442Z",
    fill: "#FFCC00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3526 6.52442C17.3526 7.65973 16.4462 8.58009 15.3282 8.58009C14.2101 8.58009 13.3037 7.65973 13.3037 6.52442C13.3037 5.3891 14.2101 4.46875 15.3282 4.46875C16.4462 4.46875 17.3526 5.3891 17.3526 6.52442Z",
    fill: "#FFCC00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6875 6.25629H13.4797V6.52442H12.6875V6.25629Z",
    fill: "#FFCC00"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.7529,
    cy: 6.52098,
    rx: 1.93647,
    ry: 1.96629,
    fill: "white"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.3271,
    cy: 6.52098,
    rx: 1.93647,
    ry: 1.96629,
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.64062 16.8024C8.64062 15.3216 9.82288 14.1211 11.2813 14.1211H14.8901C16.3485 14.1211 17.5308 15.3216 17.5308 16.8024V39.7723C17.5308 41.2531 16.3485 42.4536 14.8901 42.4536H11.2813C9.82288 42.4536 8.64062 41.2531 8.64062 39.7723V16.8024Z",
    fill: "#ED425E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.64062 16.8024C8.64062 15.3216 9.82288 14.1211 11.2813 14.1211H14.8901C16.3485 14.1211 17.5308 15.3216 17.5308 16.8024V39.7723C17.5308 41.2531 16.3485 42.4536 14.8901 42.4536H11.2813C9.82288 42.4536 8.64062 41.2531 8.64062 39.7723V16.8024Z",
    fill: "url(#paint2_linear_3286_185)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4939 27.3395V28.0636C22.1775 29.9444 25.4394 32.1215 25.2692 33.4306C25.0554 35.0758 19.501 34.7266 12.8632 32.6507C6.22536 30.5747 1.01774 27.558 1.23162 25.9128C1.38955 24.6979 4.45952 24.5705 8.72743 25.4229V24.6925C3.82135 23.7039 0.235019 23.9206 0.0396024 25.4238C-0.216398 27.3931 5.44387 30.8246 12.6822 33.0884C19.9205 35.3522 25.9958 35.5909 26.2518 33.6217C26.4597 32.0225 22.766 29.4589 17.4939 27.3395Z",
    fill: "#00AAD4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4939 27.3395V28.0636C22.1775 29.9444 25.4394 32.1215 25.2692 33.4306C25.0554 35.0758 19.501 34.7266 12.8632 32.6507C6.22536 30.5747 1.01774 27.558 1.23162 25.9128C1.38955 24.6979 4.45952 24.5705 8.72743 25.4229V24.6925C3.82135 23.7039 0.235019 23.9206 0.0396024 25.4238C-0.216398 27.3931 5.44387 30.8246 12.6822 33.0884C19.9205 35.3522 25.9958 35.5909 26.2518 33.6217C26.4597 32.0225 22.766 29.4589 17.4939 27.3395Z",
    fill: "url(#paint3_linear_3286_185)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4939 27.3395V28.0636C22.1775 29.9444 25.4394 32.1215 25.2692 33.4306C25.0554 35.0758 19.501 34.7266 12.8632 32.6507C6.22536 30.5747 1.01774 27.558 1.23162 25.9128C1.38955 24.6979 4.45952 24.5705 8.72743 25.4229V24.6925C3.82135 23.7039 0.235019 23.9206 0.0396024 25.4238C-0.216398 27.3931 5.44387 30.8246 12.6822 33.0884C19.9205 35.3522 25.9958 35.5909 26.2518 33.6217C26.4597 32.0225 22.766 29.4589 17.4939 27.3395Z",
    fill: "url(#paint4_linear_3286_185)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.7659 27.3458V28.0619C4.08296 29.9426 0.821669 32.1195 0.991825 33.4284C1.2057 35.0737 6.76009 34.7245 13.3979 32.6485C20.0357 30.5726 25.2433 27.5559 25.0294 25.9107C24.8715 24.6957 21.801 24.5684 17.5324 25.421V24.6994C22.4387 23.7134 26.0257 23.9365 26.222 25.4471C26.4793 27.4261 20.8201 30.8656 13.5818 33.1294C6.34346 35.3931 0.267099 35.624 0.00983051 33.645C-0.199095 32.0378 3.49395 29.4675 8.7659 27.3458Z",
    fill: "#00AAD4"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.7659 27.3458V28.0619C4.08296 29.9426 0.821669 32.1195 0.991825 33.4284C1.2057 35.0737 6.76009 34.7245 13.3979 32.6485C20.0357 30.5726 25.2433 27.5559 25.0294 25.9107C24.8715 24.6957 21.801 24.5684 17.5324 25.421V24.6994C22.4387 23.7134 26.0257 23.9365 26.222 25.4471C26.4793 27.4261 20.8201 30.8656 13.5818 33.1294C6.34346 35.3931 0.267099 35.624 0.00983051 33.645C-0.199095 32.0378 3.49395 29.4675 8.7659 27.3458Z",
    fill: "url(#paint5_linear_3286_185)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.7659 27.3458V28.0619C4.08296 29.9426 0.821669 32.1195 0.991825 33.4284C1.2057 35.0737 6.76009 34.7245 13.3979 32.6485C20.0357 30.5726 25.2433 27.5559 25.0294 25.9107C24.8715 24.6957 21.801 24.5684 17.5324 25.421V24.6994C22.4387 23.7134 26.0257 23.9365 26.222 25.4471C26.4793 27.4261 20.8201 30.8656 13.5818 33.1294C6.34346 35.3931 0.267099 35.624 0.00983051 33.645C-0.199095 32.0378 3.49395 29.4675 8.7659 27.3458Z",
    fill: "url(#paint6_linear_3286_185)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.23828,
    y: 16.707,
    width: 17.5162,
    height: 10.0996,
    rx: 0.930162,
    fill: "#FFCC00"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.23828,
    y: 27.1641,
    width: 17.5162,
    height: 1.1619,
    rx: 0.58095,
    fill: "#FFCC00"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6336 21.8541C16.6336 23.8533 15.0376 25.4739 13.0688 25.4739C11.0999 25.4739 9.50391 23.8533 9.50391 21.8541C9.50391 19.855 11.0999 18.2344 13.0688 18.2344C15.0376 18.2344 16.6336 19.855 16.6336 21.8541Z",
    fill: "#FF6048"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9729 22.8746C14.6179 23.424 13.9962 23.7726 13.2817 23.7726C12.1747 23.7726 11.2773 22.8966 11.2773 21.816C11.2773 20.7354 12.1747 19.8594 13.2817 19.8594C13.9918 19.8594 14.6168 20.2247 14.9729 20.7684H14.5502V20.7822C14.2472 20.4279 13.7914 20.2025 13.2817 20.2025C12.3693 20.2025 11.6297 20.9249 11.6297 21.816C11.6297 22.7071 12.3693 23.4295 13.2817 23.4295C13.7914 23.4295 14.2495 23.2289 14.5526 22.8746H14.9729Z",
    fill: "#FFE680"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9729 22.8746C14.6179 23.424 13.9962 23.7726 13.2817 23.7726C12.1747 23.7726 11.2773 22.8966 11.2773 21.816C11.2773 20.7354 12.1747 19.8594 13.2817 19.8594C13.9918 19.8594 14.6168 20.2247 14.9729 20.7684H14.5502V20.7822C14.2472 20.4279 13.7914 20.2025 13.2817 20.2025C12.3693 20.2025 11.6297 20.9249 11.6297 21.816C11.6297 22.7071 12.3693 23.4295 13.2817 23.4295C13.7914 23.4295 14.2495 23.2289 14.5526 22.8746H14.9729Z",
    fill: "url(#paint7_linear_3286_185)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9729 22.8746C14.6179 23.424 13.9962 23.7726 13.2817 23.7726C12.1747 23.7726 11.2773 22.8966 11.2773 21.816C11.2773 20.7354 12.1747 19.8594 13.2817 19.8594C13.9918 19.8594 14.6168 20.2247 14.9729 20.7684H14.5502V20.7822C14.2472 20.4279 13.7914 20.2025 13.2817 20.2025C12.3693 20.2025 11.6297 20.9249 11.6297 21.816C11.6297 22.7071 12.3693 23.4295 13.2817 23.4295C13.7914 23.4295 14.2495 23.2289 14.5526 22.8746H14.9729Z",
    fill: "url(#paint8_linear_3286_185)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3155 22.8726C14.9369 23.6355 14.16 24.1586 13.2629 24.1586C11.9937 24.1586 10.9648 23.1113 10.9648 21.8195C10.9648 20.5277 11.9937 19.4805 13.2629 19.4805C14.16 19.4805 14.9369 20.0036 15.3155 20.7664H14.8501C14.5121 20.2391 13.9275 19.8906 13.2629 19.8906C12.2168 19.8906 11.3688 20.7542 11.3688 21.8195C11.3688 22.8848 12.2168 23.7484 13.2629 23.7484C13.9275 23.7484 14.5121 23.3999 14.8501 22.8726H15.3155Z",
    fill: "#FEEF00"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3155 22.8726C14.9369 23.6355 14.16 24.1586 13.2629 24.1586C11.9937 24.1586 10.9648 23.1113 10.9648 21.8195C10.9648 20.5277 11.9937 19.4805 13.2629 19.4805C14.16 19.4805 14.9369 20.0036 15.3155 20.7664H14.8501C14.5121 20.2391 13.9275 19.8906 13.2629 19.8906C12.2168 19.8906 11.3688 20.7542 11.3688 21.8195C11.3688 22.8848 12.2168 23.7484 13.2629 23.7484C13.9275 23.7484 14.5121 23.3999 14.8501 22.8726H15.3155Z",
    fill: "url(#paint9_linear_3286_185)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9828 21.8143C14.9828 22.7602 14.2277 23.527 13.2961 23.527C12.3646 23.527 11.6094 22.7602 11.6094 21.8143C11.6094 20.8684 12.3646 20.1016 13.2961 20.1016C14.2277 20.1016 14.9828 20.8684 14.9828 21.8143Z",
    fill: "#439AE5"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9828 21.8143C14.9828 22.7602 14.2277 23.527 13.2961 23.527C12.3646 23.527 11.6094 22.7602 11.6094 21.8143C11.6094 20.8684 12.3646 20.1016 13.2961 20.1016C14.2277 20.1016 14.9828 20.8684 14.9828 21.8143Z",
    fill: "url(#paint10_linear_3286_185)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9828 21.8143C14.9828 22.7602 14.2277 23.527 13.2961 23.527C12.3646 23.527 11.6094 22.7602 11.6094 21.8143C11.6094 20.8684 12.3646 20.1016 13.2961 20.1016C14.2277 20.1016 14.9828 20.8684 14.9828 21.8143Z",
    fill: "url(#paint11_linear_3286_185)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1605 22.0611C14.1605 22.7162 13.6375 23.2473 12.9924 23.2473C12.3472 23.2473 11.8242 22.7162 11.8242 22.0611C11.8242 21.4061 12.3472 20.875 12.9924 20.875C13.6375 20.875 14.1605 21.4061 14.1605 22.0611Z",
    fill: "#FCA703"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1614 22.0279C14.1614 22.6646 13.6531 23.1808 13.026 23.1808C12.399 23.1808 11.8906 22.6646 11.8906 22.0279C11.8906 21.3912 12.399 20.875 13.026 20.875C13.6531 20.875 14.1614 21.3912 14.1614 22.0279Z",
    fill: "url(#paint12_linear_3286_185)"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.2197,
    cy: 21.9736,
    rx: 0.758756,
    ry: 0.770443,
    fill: "#F34D4D"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.2197,
    cy: 21.9736,
    rx: 0.758756,
    ry: 0.770443,
    fill: "url(#paint13_linear_3286_185)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M14.033 21.9427C14.033 22.3835 13.6811 22.7408 13.247 22.7408C12.8129 22.7408 12.4609 22.3835 12.4609 21.9427C12.4609 21.5019 12.8129 21.1445 13.247 21.1445C13.6811 21.1445 14.033 21.5019 14.033 21.9427Z",
    fill: "url(#paint14_linear_3286_185)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1658 22.805L11.0946 22.6291C10.7218 22.8753 10.4277 23.2044 10.3272 23.3381C10.143 23.5316 10.8424 23.3125 11.2151 23.1787C11.5571 23.0732 13.9958 22.1528 15.1724 21.7057C15.3785 21.6222 15.6639 21.4657 15.7808 21.3979C15.9475 21.2836 15.9416 21.2001 15.9179 21.1726C15.8521 21.0671 15.6858 21.0956 15.6109 21.1231C15.817 21.1407 15.6054 21.2917 15.4739 21.365L11.3741 22.9644C10.9531 23.171 10.826 23.1714 10.815 23.1457C10.8019 23.0886 11.0434 22.8948 11.1658 22.805Z",
    fill: "#55FFDD"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1623 22.7804L11.0913 22.603C10.7201 22.8513 10.4272 23.1831 10.3271 23.318C10.1437 23.5131 10.8402 23.2921 11.2114 23.1573C11.552 23.0508 13.9808 22.1226 15.1526 21.6718C15.3578 21.5876 15.642 21.4298 15.7585 21.3614C15.9244 21.2461 15.9186 21.1619 15.8949 21.1342C15.8294 21.0277 15.6639 21.0566 15.5892 21.0843C15.7945 21.102 15.5838 21.2542 15.4528 21.3282L11.3697 22.9411C10.9505 23.1495 10.8238 23.1499 10.8129 23.124C10.7998 23.0664 11.0404 22.8709 11.1623 22.7804Z",
    fill: "#4EA9F9"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1623 22.7804L11.0913 22.603C10.7201 22.8513 10.4272 23.1831 10.3271 23.318C10.1437 23.5131 10.8402 23.2921 11.2114 23.1573C11.552 23.0508 13.9808 22.1226 15.1526 21.6718C15.3578 21.5876 15.642 21.4298 15.7585 21.3614C15.9244 21.2461 15.9186 21.1619 15.8949 21.1342C15.8294 21.0277 15.6639 21.0566 15.5892 21.0843C15.7945 21.102 15.5838 21.2542 15.4528 21.3282L11.3697 22.9411C10.9505 23.1495 10.8238 23.1499 10.8129 23.124C10.7998 23.0664 11.0404 22.8709 11.1623 22.7804Z",
    fill: "url(#paint15_linear_3286_185)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1623 22.7804L11.0913 22.603C10.7201 22.8513 10.4272 23.1831 10.3271 23.318C10.1437 23.5131 10.8402 23.2921 11.2114 23.1573C11.552 23.0508 13.9808 22.1226 15.1526 21.6718C15.3578 21.5876 15.642 21.4298 15.7585 21.3614C15.9244 21.2461 15.9186 21.1619 15.8949 21.1342C15.8294 21.0277 15.6639 21.0566 15.5892 21.0843C15.7945 21.102 15.5838 21.2542 15.4528 21.3282L11.3697 22.9411C10.9505 23.1495 10.8238 23.1499 10.8129 23.124C10.7998 23.0664 11.0404 22.8709 11.1623 22.7804Z",
    fill: "url(#paint16_linear_3286_185)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3286_185",
    x1: 19.5995,
    y1: 1.9216,
    x2: 15.256,
    y2: 4.27865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B13434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED425E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3286_185",
    x1: 7.76068,
    y1: 9.11644,
    x2: 15.3087,
    y2: 4.35025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#770A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6D86",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3286_185",
    x1: 9.7849,
    y1: 42.4536,
    x2: 15.033,
    y2: 26.5469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A1214"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED425E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3286_185",
    x1: -0.0571762,
    y1: 25.1305,
    x2: 11.9877,
    y2: 26.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#102226"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AAD4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3286_185",
    x1: 22.6353,
    y1: 32.8923,
    x2: 16.7227,
    y2: 31.4191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#11E226"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3286_185",
    x1: 26.3166,
    y1: 25.1361,
    x2: 18.0798,
    y2: 27.3328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F3E46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AAD4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3286_185",
    x1: 3.05193,
    y1: 33.613,
    x2: 11.0136,
    y2: 31.4319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#11E226"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3286_185",
    x1: 15.093,
    y1: 21.5167,
    x2: 13.4608,
    y2: 21.522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63B4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3184D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3286_185",
    x1: 11.8232,
    y1: 21.8104,
    x2: 14.9238,
    y2: 21.8108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#207CD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.47
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3286_185",
    x1: 15.1735,
    y1: 21.8195,
    x2: 12.9736,
    y2: 21.8195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0084BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46BCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3286_185",
    x1: 14.3496,
    y1: 20.484,
    x2: 12.1452,
    y2: 22.9448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD9B08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3286_185",
    x1: 12.3572,
    y1: 23.2,
    x2: 14.5193,
    y2: 20.6218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF733"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_3286_185",
    x1: 13.2717,
    y1: 21.4293,
    x2: 12.4827,
    y2: 23.0494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD791D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE600",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_3286_185",
    x1: 13.449,
    y1: 21.2031,
    x2: 12.9052,
    y2: 22.611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9E85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F97328"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_3286_185",
    x1: 13.4872,
    y1: 22.6799,
    x2: 13.2397,
    y2: 21.1734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04C18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.552083,
    stopColor: "#E37F1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_3286_185",
    x1: 10.2969,
    y1: 23.3901,
    x2: 14.7502,
    y2: 21.8095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2584DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_3286_185",
    x1: 15.9084,
    y1: 20.9457,
    x2: 14.9429,
    y2: 21.6466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03FBFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoInc);
export default __webpack_public_path__ + "static/media/logoInc.c4c7ceeaa4efcab4e4094b7caafbd632.svg";
export { ForwardRef as ReactComponent };